import React from 'react';
import nursePortrait from '../../assets/images/nurse-portrait.png';

const SpotlightSection: React.FC = () => {
  return (
    <div className="relative w-full bg-[#f8f6f2] py-12 md:py-16 lg:py-20" id="node-12_9705">
      <div className="flex flex-col items-center justify-center px-4 md:px-8 lg:px-12">
        <div
          className="font-['Ovo',_serif] text-[#1f1f1f] text-[28px] sm:text-[32px] md:text-[40px] lg:text-[48px] xl:text-[56px] text-center uppercase mb-8 md:mb-12 lg:mb-16"
          id="node-12_9712"
        >
          <p className="block leading-[normal]">CLOUT Spotlight</p>
        </div>
        <div
          className="w-full max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] mx-auto"
          data-name="certification"
          id="node-12_9713"
        >
          <div className="relative w-full rounded-lg overflow-hidden shadow-lg">
            <img
              src={nursePortrait}
              alt="Healthcare professional in CLOUT Spotlight - showcasing excellence in medical care"
              className="w-full h-auto object-contain"
              loading="lazy"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                console.warn('Failed to load nurse portrait image');
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpotlightSection;
